<template>

    <modal ref="modal" :modal-backdrop="true">
        <template #body>
            <div class="text-center">
                <div class="text-gray-700 text-lg">
                  Tem alguém aí?
                </div>

                <p class="mt-4 mb-4">
                  Você passou  {{ time }} minutos sem interagir com a página! <br />
                  Recarregue a página e volte a navegar. ✨
                </p>

                <button
                    type="button"
                    class="btn-primary font-normal ml-1"
                    @click.prevent="reloadPage">
                        Recarregar página
                </button>
            </div>
        </template>
    </modal>

</template>

<script>

import { useAppointmentStore } from '@/Store/Appointment'
import Modal from '@/Shared/Modal/Modal'


export default {

    components: {
        Modal,
    },

    data() {
        return {
            time: 5,
            amount: 0,

            interval: null,

            showModal: false,

            appointment: useAppointmentStore(),
        }
    },

    methods: {
        handleShowModal() {
            this.showModal = true
            this.$refs.modal.showModal = true
        },


        handleClearInterval() {
            clearInterval(this.interval)
        },


        handleIcrementTime() {
            this.amount += 1

            if (this.amount < this.time)
                return


            this.handleShowModal()
            this.handleClearInterval()

        },

        reloadPage() {
            window.location.reload()
        },

        resetTime() {
            this.amount = 0

            this.handleClearInterval()

            if (!this.showModal && !this.appointment.inAppointment)
                this.interval = setInterval(this.handleIcrementTime, 60 * 1000)
        },

        createTimer() {
            this.resetTime()

            window.addEventListener('mousemove', this.resetTime)
            window.addEventListener('keydown', this.resetTime)
            window.addEventListener('scroll', this.resetTime)
        },

        removeTimer() {
            this.handleClearInterval()

            window.removeEventListener('mousemove', this.resetTime)
            window.removeEventListener('keydown', this.resetTime)
            window.removeEventListener('scroll', this.resetTime)

            this.amount = 0
            this.showModal = false

            this.interval = null
        },
    },


    mounted() {
        this.createTimer()
    },


    beforeUnmount() {
        this.removeTimer()
    },

}


</script>
